// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CloudTwoToneSvg from "@ant-design/icons-svg/es/asn/CloudTwoTone";
import AntdIcon from '../components/AntdIcon';

var CloudTwoTone = function CloudTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CloudTwoToneSvg
  }));
};

CloudTwoTone.displayName = 'CloudTwoTone';
export default React.forwardRef(CloudTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/CloudTwoTone.js
// module id = 807
// module chunks = 0